import { Button, Container, Typography } from '@mui/material'
import { useNavigate } from 'react-router'
import { Body } from 'src/components/MUIBased/Blocks/Body'
import { ContainerTitle } from 'src/components/MUIBased/Blocks/ContainerTitle'
import { Spinner } from 'src/components/MUIBased/icons'
import NavBarHeading from 'src/components/MUIBased/NavBarHeading'
import { StandardPageHeader } from 'src/components/MUIBased/pageHeaders'
import { useOpenLoopAppointments } from 'src/pages/MUIBased/CustomizedWeightManagementSubscription/hooks/useOpenLoopAppointments'
import { useOpenLoopSubscriptionProduct } from 'src/pages/MUIBased/CustomizedWeightManagementSubscription/hooks/useOpenLoopSubscriptionProduct'
import { EmailConsistencyReminder } from 'src/pages/MUIBased/CustomizedWeightManagementSubscription/EmailConsistencyReminder'

const Booking = () => {
    const { isLoading: isLoadingSubscriptionProducts, subscriptionProducts } =
        useOpenLoopSubscriptionProduct()
    const { isLoading: isLoadingAppointments, appointments } =
        useOpenLoopAppointments({ serviceLine: 'mwl' })
    const navigate = useNavigate()

    const isLoading = isLoadingSubscriptionProducts || isLoadingAppointments

    if (isLoading) {
        return <Spinner />
    }

    if (appointments && appointments.length > 0) {
        navigate(
            '/customized-weight-management-subscription/booking-confirmation'
        )
        return null
    }

    // We get the first product because they are all from same service line and have the same booking URL
    const initialApptBookingUrl =
        subscriptionProducts?.[0]?.initialApptBookingUrl

    return (
        <Body>
            <StandardPageHeader />
            <NavBarHeading href="/" showBackButton={false}>
                Customized Weight Management
            </NavBarHeading>

            <Container>
                <ContainerTitle
                    title=""
                    description="Book your initial visit with an Open Loop provider."
                />

                <EmailConsistencyReminder />

                {initialApptBookingUrl ? (
                    <Button
                        variant="contained"
                        size="large"
                        fullWidth
                        href={initialApptBookingUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Book Appointment
                    </Button>
                ) : (
                    <Typography variant="body1" color="error">
                        Unable to load booking link. Please try again later.
                    </Typography>
                )}
            </Container>
        </Body>
    )
}

export default Booking
